import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { jsx as _jsx } from "react/jsx-runtime";
const CitationPill = ({
  label,
  onClick,
  onMouseEnter,
  onMouseLeave,
  disabled
}) => {
  return /*#__PURE__*/_jsx(Clickable, {
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    inlineSize: "fit-content",
    display: "inline-block",
    cursor: disabled ? 'not-allowed' : 'pointer',
    children: /*#__PURE__*/_jsx(Flex, {
      paddingInline: "100",
      minInlineSize: "20px",
      blockSize: "20px",
      borderRadius: "full",
      backgroundColor: "fill-accent-neutral-subtle-alt",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: label
      })
    })
  });
};
CitationPill.displayName = 'CitationPill';
export default CitationPill;